module.exports = __webpack_public_path__ + "static/media/tmall.31ee7b20.png";